import React, { Component } from "react";
import { translate } from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import swal from 'sweetalert';
import { Table, Button } from 'react-bootstrap';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import MaskedFormControl from 'react-bootstrap-maskedinput';
var Config = require('../../../config');

class PhonesData extends Component {
  constructor(props) {
    super(props);
    this.addPhone = this.addPhone.bind(this);
    this.removePhone = this.removePhone.bind(this);
    this.state = {
        phone_type:"CELULAR",
        phone_number:"",
        showCheckboxes: false,
        ext:"",

        phoneTypes:[],
        errorText_phone_type:"",
        errorText_phone_number:"",
    };
  }

  //Consulta de servicios necesarios para la pantalla
  componentDidMount() {
    fetch(Config.default.apiGateway.URL+'lookups?type=PHONE_TYPE&notrender=0',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
            'Content-Type': 'application/json',
        })
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
          phoneTypes: response
        });
    })

  }

  //Evento de cambio en elementos formulario
  handleChange = (event, index, value) => {
      this.setState({
        [event.target.name]: event.target.value
      });

      if(event.target.id !== null){
        var control = document.getElementById(event.target.id);
        if(control !== null){
          if(control.required && control.className.includes('error')){
            control.classList.remove('error');
          }else if(control.required && event.target.value===""){
            control.classList.add('error');
          }
        }
      }
  }

  selectFieldHandle = (id, name, event, index, value) => {
    this.setState({[event.target.name]:event.target.value});
  }

  addPhone() {

      if (this.isValidForm()===true) {
        var flag = false;
          for (var i = 0; i < this.props.phonesAdded.length; i++) {
              if (this.props.phonesAdded[i].type === this.state.phone_type) {
                flag = true;
                break
              };
          };

          if (flag === true) {
            swal('¡El teléfono no se puede agregar!', '¡Ya se ingreso un número con ese tipo!', 'error');
          } else{
            var obj = {};
              obj.type = this.state.phone_type;
              obj.number = this.state.phone_number;
              obj.extension = this.state.ext;
            this.props.addPhoneToList(obj)
            this.setState({phone_number:""});
          }
      } else{
        swal('¡El teléfono no se puede agregar, tiene errores de validación!', '¡Los errores están marcados en rojo!', 'error');
      };
  }

  //Verificar si el formulario es valido
  isValidForm() {
    let isFormValid = true;
      const isSelectValid4 = this.showControlError('phone_number');
      if ( !isSelectValid4 ) {
        isFormValid = false;
      } 
      
      return isFormValid;
  }

  //desplegar errores en selceted
  showControlError(refName) {
    var res = null;
    var control = document.getElementById(refName);
    
    if (this.state[refName] === null || this.state[refName] === "") {
      control.classList.add('error');
      res = false;
    } else{
      if(refName === "phone_number"){
        if(this.state[refName].split('_').length!==1){
          control.classList.add('error');
          return false;
        }
      }
      control.classList.remove('error');
      res = true;
    };

    return res;
  }

  removePhone(indice){
      console.log(indice)
  }

  render() {
    const { t } = this.props;

    return (
      <div className={this.props.submenu !== undefined ?
          this.props.submenu.indexOf('/bag_entries') === -1  ? "col-xs-11" : "col-xs-12" : "col-xs-11"}
         style={this.props.submenu !== undefined ?
          this.props.submenu.indexOf('/bag_entries') === -1  ? {marginLeft:'7%'} : {padding:'0'} : {marginLeft:'7%'}
        }>
        {this.props.submenu !== undefined ?
          this.props.submenu.indexOf('/bag_entries') === -1  ?
             <hr className="avatar-hr"/>
          : null
        :null}

        <div className="col-md-12 form-group"
          style={this.props.submenu !== undefined ?
            this.props.submenu.indexOf('/bag_entries') === -1  ? null : {padding:'0'} : null
          }>
          <div className={this.state.phone_type === "OFICINA"?"col-xs-12 col-sm-4":
            this.props.submenu !== undefined ?
               this.props.submenu.indexOf('/bag_entries') === -1  ? "col-xs-12 col-sm-5" : "col-xs-12 col-sm-4"
            : "col-xs-12 col-sm-5" }
            style={this.props.submenu !== undefined ?
               this.props.submenu.indexOf('/bag_entries') === -1  ? {paddingRight:"0px"} : null: {paddingRight:"0px"}}>
            <span className="span-min">{t('content.generics.phones.type')}</span>
            <select className="form-control" name="phone_type" id="phone_type" value={ this.state.phone_type || "" } 
                onChange={ this.selectFieldHandle.bind(null,"id","phone_type") }  >
                <option value="" disabled></option>
                    {
                    this.state.phoneTypes.map(function(t) {
                      return <option key={t.id}  value={t.key}>{t.name}</option>;
                    })
                  }
            </select>
          </div>

          <div className={this.state.phone_type === "OFICINA"?"col-xs-12 col-sm-4":
            this.props.submenu !== undefined ?
               this.props.submenu.indexOf('/bag_entries') === -1  ? "col-xs-12 col-sm-5" : "col-xs-12 col-sm-4"
            :"col-xs-12 col-sm-5"}
            style={this.props.submenu !== undefined ?
               this.props.submenu.indexOf('/bag_entries') === -1  ? {paddingRight:"0px"} : null: {paddingRight:"0px"}}>
              <span className="span-min">{t('content.offers.form.number')} </span>
              
              <MaskedFormControl type='text' name="phone_number" id="phone_number" value={ this.state.phone_number } 
                    onChange={ this.handleChange } mask='111-111-1111' className="form-control" 
                    required={this.props.state.require_phone !== undefined ? this.props.state.require_phone : true} />
          </div>

          {this.state.phone_type === "OFICINA"?
            <div className="col-xs-12 col-sm-3">
              <span className="span-min">{t('content.generics.phones.ext')}  </span>
              <input name="ext" value={ this.state.ext } onChange={ this.handleChange } type="text" 
                className="form-control"/>
            </div>
          :null}

          <div className={this.state.phone_type === "OFICINA"?"col-xs-12 col-sm-1":"col-xs-12 col-sm-2"}
             style={{paddingRight:"0px"}}>
              <FloatingActionButton className="btn-plus" iconStyle={{height: 25, width: 25}} 
                disabled={this.props.disableElement} mini={true} style={{marginTop: '18px' }} 
                onClick={this.addPhone}>
                <ContentAdd/>
              </FloatingActionButton>    
          </div>
        </div>

        <hr className="avatar-hr"/>
        <div className="col-xs-12"> 
          <Table responsive hover style={{margin:"0px"}}>
            <thead>
              <tr>
                <th>{t('content.generics.phones.type')}</th>
                <th>{t('content.offers.form.number')}</th>
                <th>{t('content.generics.phones.ext')}</th>
                <th width={60}></th>
              </tr>
            </thead>
            <tbody>
             {this.props.phonesAdded.map( (phone, index) => (
                <tr key={index}>
                  <td>{phone.type}</td>
                  <td>{phone.number}</td>
                  <td>{phone.extension}</td>
                  <td width={60} style={{textAlign: "center",padding: "2px",}}>
                    <Button className="btn btn-info btn-xs" disabled={this.props.disableElement} title="Eliminar" style={{marginRight:'3px'}} onClick={(e) => this.props.removePhoneFromList(index, e)}>
                        <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
                    </Button>
                  </td>
                </tr>
                ))}
            </tbody>
          </Table>
        </div>

      </div>
    );
  }
}

export default translate('translations')(PhonesData);